// extracted by mini-css-extract-plugin
module.exports = {"error-message":"styles_error-message__1YcYs","error-icon":"styles_error-icon__2XVip"};